import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { useHistory, Link } from "react-router-dom";
import BreakpointContext from "../../contexts/breakpointContext";
import FactoryContext from "../../contexts/factoryContext";
import useUserInfo from "../../hooks/queryResults/useUserInfo";
import useUserTeam from "../../hooks/queryResults/useUserTeam";
import { getCurrentUser } from "../../store/slices/auth";
import TeamLogo from "../team/TeamLogo";
import TeamLogoAndName from "../team/TeamLogoAndName";
import Dropdown from "../ui/Dropdown";

export default function TeamLinksDropdown() {
  const breakpoints = useContext(BreakpointContext);
  const factory = useContext(FactoryContext);
  const currentUser = useSelector(getCurrentUser);
  const history = useHistory();

  const { userInfo, userInfoQuery } = useUserInfo();
  const userTeam = useUserTeam();

  if (!currentUser.isLoggedIn) return null;

  const getTeamLogoAndName = (team) => {
    return breakpoints.sm ? (
      <TeamLogoAndName team={team} size={"sm"} />
    ) : (
      <TeamLogo team={team} size={"sm"} />
    );
  };

  let selectedId;
  const teams = [];
  if (userTeam && userTeam.hasLoaded()) {
    teams.push({
      id: userTeam.obj.id,
      value: getTeamLogoAndName(userTeam),
    });
    selectedId = userTeam.obj.id;
  }

  if (userInfo?.data) {
    Object.keys(userInfo.data.franchises).forEach((franchiseId) => {
      if (franchiseId !== userTeam?.obj?.franchise) {
        if (userInfo.data.franchises[franchiseId]) {
          const franchise = factory.makeFranchise(
            userInfo.data.franchises[franchiseId]
          );
          const teamObj = franchise.getRecentTeamObj();
          const team = factory.makeTeam(teamObj);
          teams.push({
            id: team?.obj?.id,
            value: getTeamLogoAndName(team),
          });
        }
      }
    });
  } else {
    if (userInfoQuery.isLoading) {
      teams.push({ id: "loading", value: "loading..." });
    } else if (userInfoQuery.isError) {
      console.error(userInfoQuery.error);
      teams.push({
        id: "error",
        value: "an error occurred while loading teams",
      });
    }
  }

  const getLinkPathForItem = (teamItem) => {
    const teamId = teamItem.id;
    if (!teamId) return;
    if (["loading", "error"].includes(teamId)) return;

    if (!userInfo?.data?.teams) return;

    if (!userInfo.data.teams[teamId]) {
      console.error(`Could not find team ${teamId}`);
      return;
    }

    const teamObj = userInfo.data.teams[teamId];
    const team = factory.makeTeam(teamObj);

    return team.getPath();
  };

  const handleSelectTeam = (teamItem) => {
    const linkPath = getLinkPathForItem(teamItem);

    if (linkPath !== window.location.pathname) history.push(linkPath);
  };

  teams.sort((a, b) => {
    if (a.value === b.value) return 0;
    return a.value < b.value ? -1 : 1;
  });

  if (userInfo?.data && teams.length === 1) {
    const linkPath = getLinkPathForItem(teams[0]);
    return linkPath ? (
      <Link to={linkPath}>{teams[0].value}</Link>
    ) : (
      teams[0].value
    );
  }

  return (
    <Dropdown
      items={teams}
      selectedId={selectedId}
      handleSelectItem={handleSelectTeam}
    />
  );
}
